module.exports = __webpack_public_path__ + "static/media/wanmask-logo.125a4a90.png";